import { parse } from 'content-disposition';

var getPdfFileName = function getPdfFileName(contentDisposition, additionalSuffix) {
  var suffix = additionalSuffix ? " - ".concat(additionalSuffix, ".pdf") : '.pdf';
  var defaultName = "download".concat(suffix);

  try {
    var filename = parse(contentDisposition !== null && contentDisposition !== void 0 ? contentDisposition : '').parameters.filename;
    return filename ? filename.substr(0, filename.lastIndexOf('.')) + suffix : defaultName;
  } catch (_unused) {
    return defaultName;
  }
};

export default getPdfFileName;